import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import '../../styles/homepage/About.css';

function About() {
    // State to track which section is active
    const [activeSection, setActiveSection] = useState(null);

    // Function to toggle sections
    const toggleSection = (section) => {
        setActiveSection(activeSection === section ? null : section);
    };

    return (
        <div className="about-us-component">
            <div className="about-us">
                <h2>About Us</h2>
                <div className="about-us-text">
                    <p>Signifide Group delivers impact through two integrated pathways:</p>
                    <ul>
                        {/* Digital Economy Dropdown */}
                        <li onClick={() => toggleSection("kinda-digital")} className="digital-dropdown">
                            <ul>
                                <li><span>Digital Economy</span>: We design and implement scalable digital solutions that drive employment, trade, and business efficiency across Africa. Our platforms leverage technology-driven ecosystems to enhance market access, operational efficiency, and financial growth at scale.</li>
                            </ul>
                            <FontAwesomeIcon 
                                icon={activeSection === 'kinda-digital' ? faChevronUp : faChevronDown} 
                                className="dropdown-icon"
                            />
                        </li>

                        {activeSection === "kinda-digital" && (
                            <div className="kinda-digital">
                                <p>Our digital products — <span>Kinda Mashinani</span>, <span>KindaGigz</span>, <span>KindaTrade</span> and <span>KindaTech</span> — are central to this mission.</p>
                                <ul>
                                    <li>
                                        <a href="https://kinda.co.ke/" target="_blank" rel="noopener noreferrer">
                                            <span>Kinda Mashinani</span>
                                        </a>
                                        : More than just shopping—it's discovering local products. We make it easy to browse, discover and order directly from local businesses, with their own teams handling the delivery right to your door.
                                    </li>
                                    <li>
                                        <a href="https://kindagigz.com/" target="_blank" rel="noopener noreferrer">
                                            <span>KindaGigz</span>
                                        </a>
                                        : A gig employment platform built to connect millions of skilled workers to job opportunities across Africa through AI-powered job matching and geolocation services.
                                    </li>
                                    <li>
                                        <a href="https://ke.kinda.africa/" target="_blank" rel="noopener noreferrer">
                                            <span>KindaTrade</span>
                                        </a>
                                        : A last-mile distribution solution designed to streamline supply chains by connecting prime distributors, connector agents, and local retailers, optimizing efficiency in high-volume, low-margin markets.
                                    </li>
                                    <li>
                                        <a href="https://kindatech.group/" target="_blank" rel="noopener noreferrer">
                                            <span>KindaTech</span>
                                        </a>
                                        : A comprehensive ERP solution for SMEs that enhances business management, financial access, and operational growth for enterprises seeking scalability and sustainability.
                                    </li>
                                </ul>
                            </div>
                        )}

                        {/* Consultancy for Technical Assistance Dropdown */}
                        <div onClick={() => toggleSection("signifide-consult")} className="consult-dropdown">
                            <ul>
                                <li><span>Consultancy for Technical Assistance</span>: We provide technical assistance in bilateral funding, policy development, and project implementation to enhance gender and social inclusion, as well as the digital economy.</li>
                            </ul>
                            <FontAwesomeIcon 
                                icon={activeSection === 'signifide-consult' ? faChevronUp : faChevronDown} 
                                className="dropdown-icon"
                            />
                        </div>

                        {activeSection === "signifide-consult" && (
                            <div className="signifide-consult">
                                <p>Signifide Consult is committed to advancing policy development, implementation, and the digital economy, with a strong emphasis on Gender Equality and Social Inclusion (GESI) and youth empowerment at regional, national, and community levels. Our key activities include:</p>
                                <span>Policy Development and Implementation:</span>
                                <ul>
                                    <li><span>Bilateral Investment Advisory</span>: Providing expert guidance to bilateral partners to facilitate investments that promote inclusive growth and sustainable development.</li>
                                    <li><span>Program Design</span>: Creating programs that integrate GESI principles, ensuring inclusivity and addressing the needs of marginalized populations.</li>
                                    <li><span>Policy Responsiveness</span>: Collaborating with governments and organizations to develop and implement policies that promote gender equality and social inclusion.</li>
                                </ul>

                                <span>Digital Economy:</span>
                                <ul>
                                    <li><span>Digital Inclusion Initiatives</span>: Developing strategies to bridge the digital divide, ensuring marginalized groups have access to digital tools and opportunities.</li>
                                    <li><span>Capacity Building in Digital Skills</span>: Offering training programs that equip youth and marginalized communities with the skills needed to participate in the digital economy.</li>
                                </ul>

                                <span>GESI and Youth Training and Tools:</span>
                                <ul>
                                    <li><span>Comprehensive Training Programs</span>: Providing training sessions focused on GESI principles, empowering youth and marginalized groups to actively engage in economic and social activities.</li>
                                    <li><span>Development of Inclusive Tools</span>: Creating resources that facilitate the integration of GESI principles into various programs and initiatives</li>
                                </ul>
                            </div>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
}


export default About;
